module.exports = __webpack_public_path__ + "img/17.00553955.png";